import styled from 'styled-components';

const SECONDS_PER_MINUTE = 60;

const StyledTimer = styled.div`
   font-size: 13px;
   font-variant-numeric: tabular-nums;
   color: ${(props) => props.theme.secondary};
   text-align: center;
   letter-spacing: 0.03em;
`;
StyledTimer.displayName = 'StyledTimer';

type RecordingTimerProps = {
   /** Total elapsed recording time in seconds (additive across sessions). */
   totalSeconds: number;
};

function formatTime(totalSeconds: number): string {
   const minutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE);
   const seconds = totalSeconds % SECONDS_PER_MINUTE;
   return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export const RecordingTimer = (props: RecordingTimerProps): JSX.Element => (
   <StyledTimer aria-live={'off'} aria-label={`Czas nagrania: ${formatTime(props.totalSeconds)}`}>
      {formatTime(props.totalSeconds)}
   </StyledTimer>
);
